<template>
  <div class="join-form">
    <div class="join-form--left">
      <div class="join-form--left--benefits">
        <div class="join-form--left--top">
          <h2 v-if="data.state == 'NSW'" class="text-center">
            Be a part of AMA!
          </h2>
          <h2 v-else>Membership benefits</h2>
          <p>
            Membership of the Australian Medical Association gives you access to
            a comprehensive range of professional and workplace relations
            services.
          </p>
        </div>
        <div v-if="data.state == 'NSW'" class="join-form--left--list">
          <ul>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-gavel"><path d="m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8"/><path d="m16 16 6-6"/><path d="m8 8 6-6"/><path d="m9 7 8 8"/><path d="m21 11-8-8"/></svg>
              </span>
              <span class="text">
                <strong>Workplace relations and Legal Assistance</strong
                ><br />Experts to guide and support you in workplace issues and
                legal matters.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-layout-template"><rect width="18" height="7" x="3" y="3" rx="1"/><rect width="9" height="7" x="3" y="14" rx="1"/><rect width="5" height="7" x="16" y="14" rx="1"/></svg>
              </span>
              <span class="text">
                <strong>Networking and Mentorship opportunities</strong
                ><br />Join the peak medical association to network with other
                medical professionals and mentors to journey in your career.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-circle"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/></svg>
              </span>
              <span class="text">
                <strong>Advocacy and Influence</strong><br />Protect and
                advocate policies and issues that matters most to you and the
                community.
              </span>
            </li>
          </ul>
        </div>
        <div v-else class="join-form--left--list">
          <ul>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-gavel"><path d="m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8"/><path d="m16 16 6-6"/><path d="m8 8 6-6"/><path d="m9 7 8 8"/><path d="m21 11-8-8"/></svg>
              </span>
              <span class="text">
                <strong>Workplace relations</strong><br />Advisors to help guide
                you through any workplace issues.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-book-plus"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/><path d="M9 10h6"/><path d="M12 7v6"/></svg>
              </span>
              <span class="text">
                <strong>First-line legal assistance</strong><br />Support on
                professional practice, ethics, and legal obligations matters.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-library"><path d="m16 6 4 14"/><path d="M12 6v14"/><path d="M8 8v12"/><path d="M4 4v16"/></svg>
              </span>
              <span class="text">
                <strong>Medical Journal of Australia</strong><br />22 editions
                of the highly-respected journal every year.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-dollar-sign"><circle cx="12" cy="12" r="10"/><path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"/><path d="M12 18V6"/></svg>
              </span>
              <span class="text">
                <strong>List of medical services and fees</strong><br />Guidance
                to help members with costing assistance.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-layout-template"><rect width="18" height="7" x="3" y="3" rx="1"/><rect width="9" height="7" x="3" y="14" rx="1"/><rect width="5" height="7" x="16" y="14" rx="1"/></svg>
              </span>
              <span class="text">
                <strong>World-class membership portal</strong><br />Facilitates
                networking, peer mentorship, and professional opportunities.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-ticket"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="M13 5v2"/><path d="M13 17v2"/><path d="M13 11v2"/></svg>
              </span>
              <span class="text">
                <strong>Events, seminars and workshops</strong><br />Sessions
                throughout the year to enhance your skills and knowledge.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-circle"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/></svg>
              </span>
              <span class="text">
                <strong>Advocacy and Influence</strong><br />We will fight for
                important issues that matter most to you.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
              </span>
              <span class="text">
                <strong>Coaching services and career solutions</strong
                ><br />Designed to support doctors across their entire career
                lifecycle.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="join-form--right">
      <div class="join-form--step step-thrid">
        <div class="step-legend">
          <h2>Account details</h2>
          <step-circles step="1" />
        </div>
        <div class="step-intro">
          Fill out your account details for access to our membership portal.
        </div>
        <form
          @submit.prevent="next()"
          @keypress.enter.prevent
          class="nice-form"
          @input="markDirty"
        >
          <div class="step-form">
            <custom-field
              label="Title"
              type="select"
              :rules="{
                required: { message: 'Please select your title.' },
              }"
              v-model="data.prefix"
            >
              <template v-slot:options>
                <option value="" disabled="disabled"></option>
                <option value="Mr">Mr</option>
                <option value="Mrs">Mrs</option>
                <option value="Ms">Ms</option>
                <option value="Miss">Miss</option>
                <option value="Dr">Dr</option>
                <option value="Prof">Professor</option>
                <option value="A/Prof">Associate Professor</option>
                <option value="Mx">Mx</option>
              </template>
            </custom-field>
            <custom-field
              label="First name"
              maxlength="20"
              :rules="{
                required: { message: 'Please add your first name.' },
              }"
              v-model="data.name"
            />
            <custom-field
              label="Last name"
              maxlength="20"
              :rules="{
                required: { message: 'Please add your last name.' },
              }"
              v-model="data.lastname"
            />
            <custom-field
              label="Email address"
              maxlength="50"
              type="email"
              :rules="{
                required: {
                  message: 'An email address must contain a single @.',
                },
                email: {},
              }"
              v-model="data.email"
            />
            <custom-field
              label="Password"
              :type="passwordInput ? 'text' : 'password'"
              :display-errors="false"
              :rules="{
                required: true,
                regexr: { pattern: passwordPattern },
              }"
              v-model="data.password"
            >
              <template v-slot:suffix>
                <a
                  class="field-suffix"
                  :class="{ active: passwordInput }"
                  href="#"
                  @click.prevent="toggleInput('password')"
                >
                  <i class="fa fa-eye"></i>
                </a>
              </template>
            </custom-field>
            <div class="form-password-indicator">
              <div :class="{ active: passwordCheck.lowercase }">
                <i class="fal fa-check"></i>
                <i class="fas fa-circle"></i>
                <span>One lowercase character</span>
              </div>
              <div :class="{ active: passwordCheck.eigth }">
                <i class="fal fa-check"></i>
                <i class="fas fa-circle"></i>
                <span>8 characters minimum</span>
              </div>
              <div :class="{ active: passwordCheck.number }">
                <i class="fal fa-check"></i>
                <i class="fas fa-circle"></i>
                <span>One number</span>
              </div>
            </div>
            <custom-field v-if="data.promoteCode === 'AMANSW25'"
              label="Current career stage"
              type="ama-select"
              :rules="{
                required: { message: 'Please select your career stage.' },
              }"
              :custom-label="
                data.stage
                  ? options.memberships['NSWP'][data.stage].label
                  : ''
              "
              v-model="data.stage"
              @change="data.membership = ''"
            >
              <template v-slot:options="slotProps">
                <div
                  v-for="(stage, k) in options.memberships['NSWP']"
                  class="option"
                  tabIndex="-1"
                  :key="`stage-${k}`"
                  @click.prevent="slotProps.change(k)"
                >
                  <div class="option--title">{{ stage.label }}</div>
                  <div class="option--description">{{ stage.description }}</div>
                </div>
              </template>
            </custom-field>
            <custom-field v-else
              label="Current career stage"
              type="ama-select"
              :rules="{
                required: { message: 'Please select your career stage.' },
              }"
              :custom-label="
                data.stage
                  ? options.memberships[form.state][data.stage].label
                  : ''
              "
              v-model="data.stage"
              @change="data.membership = ''"
            >
              <template v-slot:options="slotProps">
                <div
                  v-for="(stage, k) in options.memberships[form.state]"
                  class="option"
                  tabIndex="-1"
                  :key="`stage-${k}`"
                  @click.prevent="slotProps.change(k)"
                >
                  <div class="option--title">{{ stage.label }}</div>
                  <div class="option--description">{{ stage.description }}</div>
                </div>
              </template>
            </custom-field>
          </div>
          <!--<div
            v-if="data.state == 'NSW' && data.stage == 'dit'"
            class="form-group ama-partner-rate"
          >
            <input
              type="checkbox"
              class="d-none"
              id="partner-rate"
              v-model="data.dit_date"
              value="1"
            />
            <label for="partner-rate">
              <span v-if="data.dit_date">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path
                    fill="currentColor"
                    d="M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
                  ></path>
                </svg>
              </span>
              <span v-else>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path
                    fill="currentColor"
                    d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
                  ></path>
                </svg>
              </span>
              <strong>Do you become an Intern in 2024?</strong>
            </label>
          </div>-->
          <div class="step-footer">
            <button
              type="button"
              @click.prevent="$emit('update:step', 1)"
              class="button button-outline-blue button-nm"
            >
              Back
            </button>
            <button type="submit" class="button button-blue button-nm">
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import stepCircles from "../stepCircles";
import customField from "../forms/customField";
export default {
  name: "step-two",
  props: ["step", "form", "options"],
  components: {
    stepCircles,
    customField,
  },
  data() {
    return {
      passwordPattern:
        "^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d*.!@$#%'\"~^&(){}\\[\\]:;<>,.?\\/~_+-=|\\]]{8,}$",
      passwordInput: false,
      data: {
        stage: "dit",
      },
      formIsDirty: false,
    };
  },
  computed: {
    passwordCheck() {
      let passwordCheck = {};
      const password = this.data.password || "";
      passwordCheck.eigth = password.length > 7;
      passwordCheck.number = !!/[0-9]+/.test(password);
      passwordCheck.lowercase = !!/[a-z]+/.test(password);
      return passwordCheck;
    },
  },
  methods: {
    toggleInput() {
      this.passwordInput = !this.passwordInput;
    },
    markDirty() {
      this.formIsDirty = true;
    },
    next() {
      let failed = false;
      for (var i in this.$children) {
        const child = this.$children[i];
        if (child.onFocus) {
          const errors = child.onBlur();
          if (errors.length) {
            failed = true;
          }
        }
      }

      if (failed) return;

      if(this.formIsDirty) {
        this.data['step'] = 2;
        window.apiTrack.post('', this.data).then(response => {
          if(response.data.success) {
            this.data['imis_id'] =  response.data.imis;
          }
        });
      }

      this.$emit("update:form", this.data);
      this.$emit("update:step", 3);
    },
  },
  mounted() {
    this.data = this.form;
    // if (window.metadata.state) {
    //   console.log('setting state from metadata', window.metadata.state);
    //   if (window.metadata.state === 'NSW') {
    //     window.location.href = 'https://australianmedicalassociation.com.au/maintenance';
    //     return;
    //   } 
    // }
    if (window.metadata.careerstage) {
      this.data.stage = window.metadata.careerstage;
    }
  },
};
</script>
